/**
 * Each PromptType is associated with a incremented value corresponding to its priority, starting from 1.
 * The lower the value, the higher the priority of the PromptType.
 */
export enum PromptType {
  COMMUNITIES_PROPOSITIONS, // 1
}
